import { render, staticRenderFns } from "./repassword.vue?vue&type=template&id=53821fa6&scoped=true&"
import script from "./repassword.vue?vue&type=script&lang=js&"
export * from "./repassword.vue?vue&type=script&lang=js&"
import style0 from "./repassword.vue?vue&type=style&index=0&id=53821fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53821fa6",
  null
  
)

export default component.exports